import { useNavigate } from "react-router-dom";
import { Rocket, ExternalLink } from "lucide-react";
import { V2Button } from "@/v2/components/ui/Button";

export default function ComingSoon({ title, description, legacyPath, eta = "Phase B–E" }) {
  const nav = useNavigate();
  return (
    <div className="v2-page" data-testid="v2-comingsoon" style={{ display: "grid", placeItems: "center", minHeight: "60vh" }}>
      <div className="v2-panel-lg" style={{ padding: 40, maxWidth: 520, textAlign: "center" }}>
        <div style={{ width: 60, height: 60, borderRadius: 14, background: "var(--v2-grad-brand)", display: "grid", placeItems: "center", margin: "0 auto 18px", color: "#fff", boxShadow: "0 12px 28px var(--v2-primary-glow)" }}>
          <Rocket size={26} />
        </div>
        <div className="v2-eyebrow" style={{ marginBottom: 6 }}>{eta}</div>
        <h2 className="v2-page-title" style={{ fontSize: 24 }}>{title}</h2>
        <p style={{ color: "var(--v2-text-muted)", fontSize: 13.5, marginTop: 8, marginBottom: 20, lineHeight: 1.5 }}>
          {description || "This module is getting the V2 premium treatment. In the meantime, you can still access it via the legacy portal."}
        </p>
        {legacyPath && (
          <V2Button variant="soft" icon={ExternalLink} onClick={() => nav(`/legacy${legacyPath}`)}>
            Open in legacy
          </V2Button>
        )}
      </div>
    </div>
  );
}
